import { authService } from '../services/auth';

export function handleResponse(response) {
    return response.text().then(data => {
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                //authService.logout();
                //window.location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}